'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import userSetAction from '../../actions/userSetAction';

class UserSetOption extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            staffId: "",
            search: "",
        };
    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    handleChange(e) {
        e.preventDefault();
        e.stopPropagation();

        let value = e.target.value;
        let index = parseInt(e.target.getAttribute("data-index"));

        this.setState({ search: value });
        userSetAction.search(value);
    }

    handleClick(e) {
        e.preventDefault();
        e.stopPropagation();

        let index = parseInt(e.currentTarget.getAttribute("data-index"));
        userSetAction.usMode(index);
        userSetAction.updating(false);

    }
    renderFilter() {
        if (this.props.usMode != 0 && !this.props.updating) {
            return (
                <div className="row ">
                    <div className="divider"></div>
                    <div className="col-sm-5">
                        <form className="form-horizontal atd-i-wp">
                            <label htmlFor="empName" className="col-xs-4 control-label">Employee: </label>

                            <div className="input-group">
                                <input type="text" className="form-control" id="empName" placeholder="Search Employee by Name or Id" onChange={this.handleChange} />
                                <span className="input-group-btn">
                                    <button className="btn btn-default" type="button">Search</button>
                                </span>
                            </div>
                        </form>
                    </div>
                    <div className="clear"></div>
                </div>
            );
        }
    }

    render() {
        return (
            <div className="us-o-w">
                <div className="row">
                    <div className="us-i-grp">
                        <div className={"us-o " + (this.props.usMode == 0 ? "us-o-active" : "")} data-index="0" onClick={this.handleClick}>
                            <div className="icon icon-xl icon-addUser"></div>
                            <div className="us-o-title">Create New Account</div>
                        </div>
                        <div className={"us-o " + (this.props.usMode != 0 ? "us-o-active" : "")} data-index="1" onClick={this.handleClick}>
                            <div className="icon icon-xl icon-editUser"></div>
                            <div className="us-o-title">Edit/Remove Employee</div>
                        </div>
                    </div>
                </div>
                {this.renderFilter()}
            </div>
        );
    }
}
export default UserSetOption;


// WEBPACK FOOTER //
// ./app/setComponents/userSetComponents/userSetOption.js